import { render } from "./Notifications.vue?vue&type=template&id=290a52a7&scoped=true&ts=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=290a52a7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290a52a7"]])

export default __exports__